export default __webpack_public_path__ + "static/media/b01.b0f9cf44.jpg";